import React, { useState, useEffect } from 'react';
import menu_data from '../MenuData';

const NavMenu = ({ closeMobileMenu }) => {
  const [currentRoute, setCurrentRoute] = useState(window.location.pathname);
  const [navTitle, setNavTitle] = useState("");

  useEffect(() => {
    const handleRouteChange = () => {
      setCurrentRoute(window.location.pathname);
    };

    window.addEventListener('popstate', handleRouteChange);

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  const isMenuItemActive = (menuLink) => {
    return currentRoute === menuLink;
  };

  const isSubMenuItemActive = (subMenuLink) => {
    return currentRoute === subMenuLink;
  };

  const openMobileMenu = (menu) => {
    if (navTitle === menu) {
      setNavTitle("");
    } else {
      setNavTitle(menu);
    }
    closeMobileMenu(); // إغلاق القائمة عند النقر على أي عنصر
  };

  const handleLinkClick = (e, link) => {
    e.preventDefault();
    if (link === "#") {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      closeMobileMenu();
      return;
    }
    const targetElement = document.querySelector(link);
    if (targetElement) {
      const offset = 100; // عدد البيكسلات المضافة
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });

      closeMobileMenu(); 
    }
  };

  return (
    <div>
      {menu_data.map((menu) => (
        <li
          key={menu.id}
          className={`${menu.has_dropdown ? 'menu-item-has-children' : ''} ${
            isMenuItemActive(menu.link) ||
            (menu.sub_menus &&
              menu.sub_menus.some((sub_m) => sub_m.link && isSubMenuItemActive(sub_m.link)))
              ? 'active'
              : ''
          }`}
        >
          <a
            href={menu.link}
            className={`${navTitle === menu.title ? 'show' : ''}`}
            onClick={(e) => handleLinkClick(e, menu.link)}
          >
            {menu.title}
          </a>
          {menu.has_dropdown && (
            <ul className={`sub-menu ${navTitle === menu.title ? 'show' : ''}`}>
              {menu.sub_menus &&
                menu.sub_menus.map((sub_m, i) => (
                  <li key={i} className={`${sub_m.link && isSubMenuItemActive(sub_m.link) ? 'active' : ''}`}>
                    <a
                      href={sub_m.link}
                      onClick={(e) => handleLinkClick(e, sub_m.link)}
                    >
                      <span>{sub_m.title}</span>
                    </a>
                  </li>
                ))}
            </ul>
          )}
        </li>
      ))}
    </div>
  );
};

export default NavMenu;
